/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestStartPdfExport
 */
export interface RequestStartPdfExport {
    /**
     * 
     * @type {string}
     * @memberof RequestStartPdfExport
     */
    pageQuery?: string;
}

export function RequestStartPdfExportFromJSON(json: any): RequestStartPdfExport {
    return RequestStartPdfExportFromJSONTyped(json, false);
}

export function RequestStartPdfExportFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestStartPdfExport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pageQuery': !exists(json, 'page_query') ? undefined : json['page_query'],
    };
}

export function RequestStartPdfExportToJSON(value?: RequestStartPdfExport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page_query': value.pageQuery,
    };
}


